/* tslint:disable */
/* eslint-disable */
/**
 * Main data new API
 * Auto-generated openapi scheme for main-data-new API
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface WriteOnlyDiemsRates
 */
export interface WriteOnlyDiemsRates {
    /**
     * 
     * @type {string}
     * @memberof WriteOnlyDiemsRates
     */
    id?: string;
    /**
     * 
     * @type {number}
     * @memberof WriteOnlyDiemsRates
     */
    rate: number;
    /**
     * 
     * @type {number}
     * @memberof WriteOnlyDiemsRates
     */
    intervalFrom: number;
    /**
     * 
     * @type {number}
     * @memberof WriteOnlyDiemsRates
     */
    intervalTo: number;
    /**
     * 
     * @type {number}
     * @memberof WriteOnlyDiemsRates
     */
    replacementByMealsRate: number;
    /**
     * 
     * @type {number}
     * @memberof WriteOnlyDiemsRates
     */
    replacementByMealsCount: number;
    /**
     * 
     * @type {Date}
     * @memberof WriteOnlyDiemsRates
     */
    start: Date;
    /**
     * 
     * @type {Date}
     * @memberof WriteOnlyDiemsRates
     */
    end: Date;
}

export function WriteOnlyDiemsRatesFromJSON(json: any): WriteOnlyDiemsRates {
    return WriteOnlyDiemsRatesFromJSONTyped(json, false);
}

export function WriteOnlyDiemsRatesFromJSONTyped(json: any, ignoreDiscriminator: boolean): WriteOnlyDiemsRates {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': !exists(json, 'id') ? undefined : json['id'],
        'rate': json['rate'],
        'intervalFrom': json['interval_from'],
        'intervalTo': json['interval_to'],
        'replacementByMealsRate': json['replacement_by_meals_rate'],
        'replacementByMealsCount': json['replacement_by_meals_count'],
        'start': (new Date(json['start'])),
        'end': (new Date(json['end'])),
    };
}

export function WriteOnlyDiemsRatesToJSON(value?: WriteOnlyDiemsRates | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'rate': value.rate,
        'interval_from': value.intervalFrom,
        'interval_to': value.intervalTo,
        'replacement_by_meals_rate': value.replacementByMealsRate,
        'replacement_by_meals_count': value.replacementByMealsCount,
        'start': (value.start.toISOString()),
        'end': (value.end.toISOString()),
    };
}


